import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ButtonIcon } from '@morressier/alembic';

const EmptyState = ({
  title,
  subTitle,
  headingText,
  subHeadingText,
  isToolTip,
  marginTops = 6,
  paddings = 4
}: {
  title: string;
  subTitle: React.ReactNode;
  headingText?: string;
  subHeadingText?: string;
  isFileIcon?: boolean;
  bgColor?: string;
  icon?: IconProp;
  borderRadius?: number;
  isToolTip?: boolean;
  marginTops?: number;
  paddings?: number;
}) => {
  return (
    <Flex flexDirection="column">
      {headingText && (
        <Text textStyle="headingSection">
          {headingText}
          {isToolTip && (
            <Tooltip
              hasArrow
              shouldWrapChildren
              placement="top"
              label={subHeadingText}
              borderRadius={4}
            >
              <ButtonIcon
                size="small"
                ml={1}
                ariaLabel="Help Icon"
                icon={<FontAwesomeIcon icon={faInfoCircle} />}
              />
            </Tooltip>
          )}
        </Text>
      )}
      {subHeadingText && !isToolTip && <Text>{subHeadingText}</Text>}
      <Flex
        flexDirection="column"
        gap={8}
        textAlign="left"
        marginX="auto"
        marginTop={marginTops}
        bgColor="neutralPrimaryFill"
        padding={paddings}
        width={'100%'}
      >
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">{title}</Text>
          <Text textStyle="textBody">{subTitle}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default EmptyState;
